import { createAction } from '@ngrx/store';
import { ActivityDomainTabModel } from 'src/app/core/models/activity-model/activity-domain-tab.model';

export const addActivity = createAction(
    '[Activity] Add activity',
    (activity: ActivityDomainTabModel) => ({ activity })
);
export const ActivityActionType: string[] = [
    addActivity.type
];